export default __webpack_public_path__ + "static/media/no_data.83524f33.png";